import { Box, Center, Text, Icon, Flex } from '@chakra-ui/react';
import React from 'react';
import { BiError } from '@react-icons/all-files/bi/BiError';
import { Greetings } from '../view/GreetingView';
export class APPDown extends React.Component {
    render() {
        return (React.createElement(Center, null,
            React.createElement(Box, { mt: '20%' },
                React.createElement(Greetings, null),
                React.createElement(Flex, { w: '100%', justify: 'center', flexDirection: 'column', align: 'center' },
                    React.createElement(Icon, { as: BiError, color: 'red', width: '35px', height: '35px' }),
                    React.createElement(Text, { mt: '15px', color: 'lightgray' }, "Sorry, but our servers have went down. Please try again in a bit.")))));
    }
}
